import { Record } from 'immutable';

export default class PaymentCollectionRecord extends Record({
  id: undefined,
  createdAt: undefined,
  createdBy: undefined,
  finished: undefined,
  finishedAt: undefined,
  links: undefined,
}) {
}
